import React, {useEffect} from 'react'
import ReactDOM from 'react-dom/client'
import {Provider, useSelector, useDispatch} from 'react-redux'
import { useLocation, BrowserRouter, Routes, Route, Link, useNavigate, Navigate, Outlet} from 'react-router-dom'
import LoginPage from './pages/login.page'
import NoPage from './pages/no.page'
import AdminDrawer from '@components/AdminDrawer'
import LogoutPage from '@pages/logout.page'
import RootPage from '@pages/root.page'
import { createTheme, ThemeProvider, CssBaseline, Container, Typography } from '@mui/material'
import {GlobalStyle as gs} from '@src/GlobalStyle'
import { CONTEXT_PATH } from '@util/constant'
import { isAdmin} from '@util/helper'
import GlobalSnackbar from '@components/GlobalSnackbar'
import WelcomePage from '@pages/welcome.page'
import RepairPage from '@pages/repair.page'
import UserDrawer from '@components/UserDrawer'
import DashboardPage from '@pages/dashboard.page'
import WalletPage from '@pages/wallet.page'
import SignalPage from '@pages/signal.page'
import UserPage from '@pages/user.page'
import UscPage from '@pages/usc.page'

const theme = createTheme({
  typography: {
    fontSize: 14, // Adjust the base font size
  },
  components: {
    MuiTableCell: {
      defaultProps: {
        size: 'small', // Set the default size to "small"
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'small',
        variant:'outlined',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant:'outlined',
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
    },
  },
  palette: {
    primary: {
      main:gs.colors.main,
      bar:gs.colors.bar,
    },
  },
  // spacing: 8,
  // You can add more customizations to the theme here
})


const AdminRoute = ({children}) => {
  const account = useSelector(state => state.accountReducer)
  return isAdmin(account) ? <Outlet /> : <Navigate to='/logout' />
}

const App = () => {
  const account = useSelector(state => state.accountReducer)
  useEffect(() => {
    console.log('App mounted')

  }, [])

  return (
    <ThemeProvider  theme={theme}>
      <GlobalSnackbar />
      <CssBaseline />
      <BrowserRouter >
        <Routes>
          <Route path='/' element={<RootPage />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path='/logout' element={<LogoutPage />} />
          <Route path='/welcome' element={<WelcomePage />} />
          <Route path='/home' element={<NoPage />} />
          <Route path='/repair/' element={<RepairPage/>} />
          <Route path='/repair/:message' element={<RepairPage/>} />

          <Route path='/admin' element={<AdminRoute/>}>
            <Route path='' element={<AdminDrawer />}>
              <Route index element={<DashboardPage />} />
              <Route path='dashboard' element={<DashboardPage/>} />
              {/* signal 토픽은 admin 전용이다 -- BrokerController가 isAdmin을 서버에서 다시
                  확인하고 아니면 요청 전체를 거부하므로, 이 라우트가 /admin 밖에 있으면
                  페이지가 뜨자마자 /broker 호출이 실패한다. */}
              <Route path='signal' element={<SignalPage/>} />
              <Route path='user' element={<UserPage/>} />
              <Route path='*' element={<NoPage />} />
            </Route>
          </Route>
          <Route path='/user' element={<AdminRoute/>}>
            <Route path='' element={<AdminDrawer />}>
              <Route index element={<WalletPage />} />
              <Route path='usc' element={<UscPage/>} />
              <Route path='usc/:userId' element={<UscPage/>} />
              <Route path='wallet' element={<WalletPage/>} />
              <Route path='wallet/:userId' element={<WalletPage/>} />
              <Route path='*' element={<NoPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
